export default {
  placeholder: 'Indiferente',
  selected: 'selecionado',
  selectedPlural: 'selecionados',
};
